(function () {
    'use strict';

    angular
        .module('app.campaign.campaignForm', ['angularFileUpload'])
        .controller('CampaignFormCtrl', ['$scope', '$rootScope', '$sanitize', '$sce', 'CampaignFormService', 'campaignAdvertiserManagePageAddInfluencersService', 'localStorageService', '$modal', '$modalInstance', 'campaignConsts', 'commonConsts', '$location', '$anchorScroll', '$timeout', 'TRACK_EVENTS',
            function ($scope, $rootScope, $sanitize, $sce, CampaignFormService, campaignAdvertiserManagePageAddInfluencersService, localStorageService, $modal, $modalInstance, campaignConsts, commonConsts, $location, $anchorScroll, $timeout, TRACK_EVENTS) {
                /**
                 * Init
                 */
                $scope.title = $scope.editMode ? 'Edit campaign' : 'Add new campaign';
                $scope.campaignTypeConsts = angular.copy(campaignConsts.Types);
                $scope.keywordTypeConsts = angular.copy(commonConsts.KeywordTypes);
                $scope.keywordStatusConsts = angular.copy(commonConsts.KeywordStatuses);
                $scope.forOneInfluencer = $scope.forOneInfluencer || false;

                $scope.advertiserID = $rootScope.currentUser.company != null ? $rootScope.currentUser.company.id : null;

                if ($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
                    $scope.advertiserID = $rootScope.sideMenuSelections.advertiserId;
                }

                $scope.termList = [];
                $scope.customTerm = {
                    value: ''
                };

                $scope.selectedTermList = [];
                $scope.mentionList = [];
                $scope.newMention = null;
                $scope.influencerList = [];
                $scope.newInfluencer = '';
                $scope.fileList = [];
                $scope.newFile = '';
                $scope.showReviewCampaign = false;
                $scope.additionalInfo = { value: '' };

                $scope.keywordList = [];
                $scope.urlList = [];
                $scope.hashtagList = [];

                $scope.format = 'MM-dd-yyyy';

                var MSG = {
                        CUSTOM_TERM_DUPLICATION: 'Term has already been existed.',
                        OVER_MAX_UPLOAD_FILE_SIZE: ' is over permissive maximum size (256MB)',
                        MENTION_IS_EXISTED_IN_SYSTEM: ' has existed in system'
                    };

                var INFLUECNER_STATUS = {
                    ACCEPTED: "accepted"
                };

                var MAX_UPLOAD_FILE_SIZE = 1024*1024*256;

                $scope.influencerData = {
                    status: null
                };

                /**
                 * Campaign types
                 */
                $scope.campaignTypes = angular.copy($rootScope.definitions.campaignTypes);

                $scope.selectCampaignType = function(campaignType) {
                    $scope.campaignType = campaignType;
                    $scope.getSelectableCampaignTerms(campaignType.value);
                }

                /**
                 * Terms
                 */
                function getInputTagByDataType(model, paramType, paramName, modelNameInHTML) {
                    var inputTag = '';

                    switch (paramType) {
                        case 'date':
                            model.params[paramName].value = moment().format('DD MMM YYYY'); // today
                            inputTag = '<input type="text" ng-click="$event.stopPropagation()" class="variable-input ' + paramType + ' text-field" ng-model="' + modelNameInHTML + '.params[\'' + paramName + '\'].value" ng-model-options="{ getterSetter: true }"/>';
                            break;
                        case 'int':
                            inputTag = '<input type="number" min="0" ng-click="$event.stopPropagation()" class="variable-input ' + paramType + ' text-field no-spinners" ng-model="' + modelNameInHTML + '.params[\'' + paramName + '\'].value" ng-model-options="{ getterSetter: true }"/>';
                            break;    
                        default:
                            inputTag = '<input type="text" ng-click="$event.stopPropagation()" class="variable-input ' + paramType + ' text-field" ng-model="' + modelNameInHTML + '.params[\'' + paramName + '\'].value" ng-model-options="{ getterSetter: true }"/>';
                            break;
                    }

                    return inputTag;
                }

                function replaceParamMarkupByInputTag(model, text, modelNameInHTML) {
                    var sourceText = angular.copy(text);
                    var regexFindParamMarkup = new RegExp("{{([a-zA-Z1-9_]*)}}", "g");
                    var paramMarkupResults = sourceText.match(regexFindParamMarkup);

                    if (paramMarkupResults) {
                        model.params = {};
                        var display = $sanitize(sourceText);

                        paramMarkupResults.forEach(function (paramMarkup) {
                            var regexFindParamType = new RegExp("{{([a-zA-Z1-9]*)", "g");
                            var paramType = regexFindParamType.exec(paramMarkup)[1];
                            var paramName = paramMarkup.replace('{{','').replace('}}','');

                            model.params[paramName] = { value: '', type: paramType };

                            var inputTag = getInputTagByDataType(model, paramType, paramName, modelNameInHTML);
                            display = display.replace('{{' + paramName + '}}', inputTag);
                        });

                        model.display = $sce.trustAsHtml(display);
                    } else {
                        model.display = $sanitize(sourceText);
                    }
                }

                $scope.getSelectableCampaignTerms = function(campaignType) {
                    CampaignFormService.getSelectableCampaignTerms($scope.advertiserID, campaignType, false) // loader = false
                        .then(function(responseCampaignTerms){
                            $scope.termList = responseCampaignTerms.data;
                            angular.forEach($scope.termList, function(item){
                                item.ticked = false;
                                item.customed = item.companyId !== null;

                                replaceParamMarkupByInputTag(item, item.summary, 'term');
                            });

                            if ($scope.editMode) {
                                loadCampaignTerms($scope.editingCampaignId, $scope.editingCampaignInfluencerId);
                            }
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                $scope.selectTerm = function(term) {
                    angular.forEach($scope.termList, function(item) {
                        if(term.id == item.id) {
                            item.ticked = !item.ticked;

                            if (item.ticked) {
                                item.action = item.action === "delete" ? "edit" : "add";
                            } else {
                                item.action = item.action === "edit" ? "delete" : null;
                            }
                        }
                    })
                }

                var gotoBottomTermList = function() {
                    $timeout(function() {
                        $location.hash('addCustomTermID');
                        $anchorScroll();
                    });
                };

                $scope.onCustomTermKeyPress = function(keyEvent) {
                    if (keyEvent.which === 13) {
                        $scope.addCustomTerm();
                    }
                }

                $scope.addCustomTerm = function() {
                    var summary = $scope.customTerm.value;

                    if(summary != '') {
                        // check custom term duplication
                        for (var i = 0; i < $scope.termList.length; i++) {
                            var term = $scope.termList[i];
                            if (!term.hidden && term.summary === summary) {
                                showError(MSG.CUSTOM_TERM_DUPLICATION);
                                return;
                            }
                        }

                        var params = {
                            summary: summary,
                            campaignType: $scope.campaignType.value,
                            companyId: $scope.advertiserID
                        }

                        CampaignFormService.addCustomTerm(params, true)
                            .then(function(response) {
                                var newTerm = {
                                    id: response.data.id,
                                    index: $scope.termList.length + 1,
                                    summary: summary,
                                    display: $sanitize(summary),
                                    customed: true,
                                    ticked: true,
                                    action: "add",
                                }

                                $scope.termList.push(newTerm);
                                $scope.customTerm.value = '';
                                gotoBottomTermList();
                            }, function (err) {
                                $rootScope.handleRequestError(err, $scope);
                            });
                    }
                }

                $scope.deleteCustomTerm = function(item) {
                    if (item.id !== null) {
                        CampaignFormService.deleteCustomTerm(item.id, true)
                            .then(function () {
                                item.hidden = true;
                                item.ticked = false;
                                item.action = "delete";
                            }, function (err) {
                                $rootScope.handleRequestError(err, $scope);
                            });
                    } else {
                        var index = $scope.termList.indexOf(item);
                        $scope.termList.splice(index, 1);
                    }
                }

                /**
                 * Mentions
                 */
                $scope.availableMentions = function(val) {
                    return CampaignFormService.searchMentionByNameAndLanguageId(encodeURIComponent(val), 45, false)
                        .then(function(response) {
                            var matches = response.mention_list.map(function(item) {
                                return { id: item.id, name: item.keyword, type: item.keywordType.id, status: item.status };
                            });

                            return matches || [];
                        }, function(err) {
                            $rootScope.handleRequestError(err, $scope);
                            return [];
                        });
                };

                $scope.afterSelectMention = function(item) {
                    var currentMentionIds = $scope.mentionList.map(function(row){
                        return row.id;
                    });
                    if (currentMentionIds.indexOf(item.id) === -1) {
                        $scope.mentionList.push(item);
                    } else {
                        $(".modal-dialog .modal-content").effect("shake")
                    }
                }

                $scope.mentionIcon = function(mentionType) {
                    return CampaignFormService.getMentionIcon(mentionType);
                }

                $scope.onMentionKeyPress = function(keyEvent, newMention) {
                    if (keyEvent.which === 13 && newMention) {
                        $scope.addNewMention(newMention);
                    }
                }

                var checkExistingMention = function (val) {
                    return CampaignFormService.searchMentionByNameAndLanguageId(encodeURIComponent(val), 45, true)
                        .then(function(response) {
                            var result = false; 
                            for (var i=0; i<response.mention_list.length; i++) {
                                if (val.toUpperCase() ===response.mention_list[i].keyword.toUpperCase()) {
                                    result = !result;
                                    break;
                                }
                            }
                            return result;
                        }, function(err) {
                            return false;
                        });
                };

                $scope.addNewMention = function(newMention) {
                    checkExistingMention(newMention)
                        .then (function (response){
                            if (response) {
                                showError(newMention + MSG.MENTION_IS_EXISTED_IN_SYSTEM);
                            }
                            else {
                                var typeid = null;
                                var UrlPattern = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                                if(!UrlPattern.test(newMention) && newMention.indexOf("#") != 0){
                                    typeid = $scope.keywordTypeConsts.KEYWORD;
                                } else if(UrlPattern.test(newMention) && newMention.indexOf("#") != 0){
                                    typeid = $scope.keywordTypeConsts.URL;
                                } else if(!UrlPattern.test(newMention) && newMention.indexOf("#") == 0){
                                    typeid = $scope.keywordTypeConsts.HASH_TAG;
                                }

                                $rootScope.newMentionModalHandler(newMention, typeid, -1, function(createdMention) {
                                    if(createdMention){
                                        $scope.mentionList.push({ id: createdMention.id, name: createdMention.keyword, type: createdMention.keywordType, status: createdMention.status });
                                        $scope.selectedMention = null;
                                    }
                                });
                            }

                        })
                }

                $scope.removeMention = function(index) {
                    $scope.mentionList.splice(index, 1);
                }

                /**
                 * Influencers
                 */
                $scope.availableInfluencers = function(val) {
                    return campaignAdvertiserManagePageAddInfluencersService.searchInfluencerForCampaign(val, true)
                        .then(function(response) {
                            var availableInfluencers = [];

                            for (var i = 0; i < response.influencer_list.length; i++) {
                                var item = response.influencer_list[i];

                                if ($scope.isInfluencerAdded(item.id)){
                                    if (response.influencer_list.length == 1 && val == item.domain){
                                        $rootScope.handleRequestError({message: val + ' was already added.'}, $scope);
                                    }
                                }
                                else {
                                    availableInfluencers.push({ id: item.id, domain: item.domain, profile_image: item.profile_image, influencer_id: item.influencerId });
                                }
                            }
                            return availableInfluencers;

                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                };

                $scope.isInfluencerAdded = function(id){
                     for (var i = 0; i < $scope.influencerList.length; i++){
                         var influencer = $scope.influencerList[i];
                         if (influencer.action != 'delete' && influencer.id == id){
                             return true;
                         }
                     }
                     return false;
                }

                $scope.afterSelectInfluencer = function(item) {
                    var currentBlogIds = $scope.influencerList.map(function(row){
                        return row.id;
                    });
                    if (currentBlogIds.indexOf(item.id) === -1) {
                        item.status = $scope.influencerData.status ? 'accepted' : ''; 
                        $scope.influencerList.push(item);
                    } else {
                        $(".modal-dialog .modal-content").effect("shake")
                    }
                    $scope.selectedInfluencer = null;
                    $scope.influencerData.status = null;
                }

                $scope.removeInfluencer = function(index) {
                    $scope.influencerList.splice(index, 1);
                }

                /**
                 * Files
                 */

                function isImageFile(contentType) {
                    var imageRegex = new RegExp(/image\/.*/g);
                    return imageRegex.test(contentType);
                }

                function getThumbnailSrc(contentType, fileId) {
                    if (isImageFile(contentType)) {
                        return CampaignFormService.getUploadedFileUrl(fileId);
                    }

                    return '/images/attach.png';
                }

                function uploadingSuccess(uploadingResponse, fileObj) {
                    var uploadedFile = uploadingResponse.data;

                    fileObj.fileId = uploadedFile.id;
                    fileObj.contentType = uploadedFile.contentType;
                    fileObj.action = "add";
                    fileObj.thumbnail = getThumbnailSrc(fileObj.contentType, fileObj.fileId);
                    fileObj.downloadLink = CampaignFormService.getUploadedFileUrl(fileObj.fileId);

                    return fileObj;
                }

                function uploadingFail(fileObj) {
                    fileObj.thumbnail = '/images/ico/exclamation.jpg';
                    fileObj.errorMessage = 'Uploading failed. Please try again.';
                    return fileObj;
                }

                $scope.uploadFiles = function(files) {
                    files.forEach(function (file) {
                        if (file.size > MAX_UPLOAD_FILE_SIZE) {
                            showError(file.name + MSG.OVER_MAX_UPLOAD_FILE_SIZE);
                        }
                        else {
                            var fileIndex = $scope.fileList.length;
                            $scope.fileList[fileIndex] = {
                                name: file.name,
                                thumbnail: '/images/ajax-loader-small.gif'
                            }

                            CampaignFormService.uploadFile(file, false).then(function (response) {
                                $scope.fileList[fileIndex] = uploadingSuccess(response.data, $scope.fileList[fileIndex]);
                            }, function (err) {
                                $scope.fileList[fileIndex] = uploadingFail($scope.fileList[fileIndex]);
                            });
                        }
                    });
                }

                $scope.deleteFile = function(index) {
                    var deletingFile = $scope.fileList[index];
                    deletingFile.hidden = true;

                    if (deletingFile.id === null || deletingFile.id === undefined) { // id of ProjectFile/CampaignFile record
                        CampaignFormService.removeFile(deletingFile.fileId, false).then(function () {
                            $scope.fileList.splice(index, 1);
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                    } else {
                        deletingFile.action = 'delete';
                    }
                }

                /**
                 * Save button
                 */

                function getSelectedMentions() {
                    var selectedMentions = [];
                    angular.forEach($scope.mentionList, function(mention) {
                        selectedMentions.push(mention.id);
                    });

                    return selectedMentions;
                }

                function showError(error) {
                    $rootScope.handleRequestError({message: error}, $scope);
                }

                function isMissingParamValue(term) {
                    if (term.ticked && term.hasParams && term.params !== undefined && term.params !== null) {
                        var termParamKeys = Object.keys(term.params);
                        for (var i = 0; i < termParamKeys.length; i++) {
                            if (!term.params[termParamKeys[i]].value) return true;
                        }
                    }

                    return false;
                }

                function validateTermValues(){
                    for (var i = 0; i < $scope.termList.length; i++) {
                        var term = $scope.termList[i];
                        if (isMissingParamValue(term)) {
                            return false;
                        }
                    }

                    return true;
                }

                function getSelectedTerms() {
                    var selectedTerms = [];
                    for (var i = 0; i < $scope.termList.length; i++) {
                        var term = $scope.termList[i];

                        if (isMissingParamValue(term)){
                            return [];
                        }

                        if(term.ticked) {
                            selectedTerms.push({
                                termId: term.id,
                                params: term.params,
                                action: term.action,
                                id: term.campaignTermId
                            });
                        } else {
                            if (term.action === "delete") {
                                selectedTerms.push({
                                    termId: term.id,
                                    params: term.params,
                                    action: term.action,
                                    id: term.campaignTermId
                                });
                            }
                        }
                    }

                    return selectedTerms;
                }


                var addAcceptedInfluencerToCampaign = function (campaignId, influencerList) {

                    var acceptedList = [];
                    for (var i=0; i < influencerList.length; i++) {
                        var inf = influencerList[i];
                        if (inf.status === INFLUECNER_STATUS.ACCEPTED) {
                            var acceptedInf = {
                                influencer_id: inf.id,
                                action: 'add',
                                domain: inf.domain,
                                profile_image: inf.profile_image,
                                status: inf.status
                            }; 
                            acceptedList.push(acceptedInf);
                        }
                    }

                    if (acceptedList.length > 0) {
                        var data = {
                            campaign_id: campaignId,
                            influencers: acceptedList
                        };

                        campaignAdvertiserManagePageAddInfluencersService.saveInfluencerToCampaign(data, true)
                            .then(function (response) {
                                $rootScope.$broadcast('reload_campaignList', { advertiserId : $scope.selectedAdvertiser });
                            }, function (response) {
                                $rootScope.handleRequestError(response, $scope);
                            });
                    }
                };

                function getSelectedInfluencerIds() {
                    return $scope.influencerList
                        .filter(function(item) {
                            return item.status !== 'accepted';
                        })
                        .map(function(row){
                            return row.id;
                        });
                }

                function validateCampaign(name, type, brief, mentions, terms){
                    if (name == null || name == ''){
                        showError('Please enter campaign name.');
                        return false;
                    }

                    if (type == null || type == ''){
                        showError('Please enter campaign type.');
                        return false;
                    }

                    if (brief == null || brief == ''){
                        showError('Please enter campaign brief.');
                        return false;
                    }

                    if (type == campaignConsts.Types.CAMPAIGN_CREATION && mentions.length == 0){
                        showError('Please enter at least on mention for campaign.');
                        return false;
                    }

                    if (!validateTermValues()){
                        showError('The campaign terms misses one or more parameters. Please add.');
                        return false;
                    }

                    var addedTerms = [];
                    for (var i = 0; i < terms.length; i++){
                        if (terms[i] != null && terms[i].action != 'delete'){
                            addedTerms.push(terms[i]);
                        }
                    }

                    if (addedTerms.length === 0) {
                        showError('Please select at least one term for campaign.');
                        return false;
                    }

                    return true;
                }

                function sendRequestAddNewCampaign(needSendEmail) {
                    var selectedMentions = getSelectedMentions();
                    var selectedTerms = getSelectedTerms();
                    var influencerIds = getSelectedInfluencerIds();

                    if (!validateCampaign($scope.campaignName, $scope.campaignType.value, $scope.campaignBrief, selectedMentions, selectedTerms)){
                        return;
                    }

                    var params = {
                        name: $scope.campaignName,
                        projectType: $scope.campaignType.value,
                        brief: $scope.campaignBrief || null,
                        additionalInfo: $scope.additionalInfo.value || null,
                        keywordIds: selectedMentions,
                        terms: selectedTerms,
                        influencerIds: influencerIds,
                        advertiserID: $scope.advertiserID,
                        needSendEmail: needSendEmail,
                        files: $scope.fileList
                    }

                    CampaignFormService.addNewCampaign(params, true)
                        .then(function(response) {
                            // Mixpanel tracking add campaign
                            analytics.track(
                                TRACK_EVENTS.CREATE_CAMPAIGN.EVT_NAME,
                                {
                                    "action": "Create",
                                    "item": TRACK_EVENTS.CREATE_CAMPAIGN.ITEM_NAME,
                                    "target_type": TRACK_EVENTS.CREATE_CAMPAIGN.ITEM_NAME,
                                    "target_name": params.name,
                                    "target_id": response.data.id,
                                    "params": params
                                }
                            );
                            addAcceptedInfluencerToCampaign(response.data.id, $scope.influencerList); // add Accepted Influencer
                            $scope.closeCampaignModal();
                            $rootScope.$broadcast('reload_campaignList', { advertiserId : $scope.selectedAdvertiser });
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                function sendRequestEditCampaign(needSendEmail) {
                    var selectedMentions = getSelectedMentions();
                    var selectedTerms = getSelectedTerms();
                    var influencerIds = getSelectedInfluencerIds();

                    if (!validateCampaign($scope.campaignName, $scope.campaignType.value, $scope.campaignBrief, selectedMentions, selectedTerms)){
                        return;
                    }

                    var params = {
                        id: $scope.editingCampaignId,
                        name: $scope.campaignName,
                        projectType: $scope.campaignType.value,
                        brief: $scope.campaignBrief || null,
                        additionalInfo: $scope.additionalInfo.value || null,
                        keywordIds: selectedMentions,
                        terms: selectedTerms,
                        influencerIds: influencerIds,
                        needSendEmail: needSendEmail,
                        files: $scope.fileList
                    }

                    CampaignFormService.updateCampaign(params, true)
                        .then(function(response) {
                            addAcceptedInfluencerToCampaign(response.data.id, $scope.influencerList); // add Accepted Influencer
                            $scope.closeCampaignModal();
                            $rootScope.$broadcast('reload_campaignList', { advertiserId : $scope.selectedAdvertiser });
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                function sendRequestEditCampaignForInfluencer(needSendEmail) {
                    var selectedTerms = getSelectedTerms();

                    var params = {
                        terms: selectedTerms,
                        campaignInfluencerId: parseInt($scope.editingCampaignInfluencerId),
                        campaignId: parseInt($scope.editingCampaignId),
                        needSendEmail: needSendEmail
                    }

                    CampaignFormService.updateCampaignForInfluencer(params, true)
                        .then(function(response) {
                            $scope.closeCampaignModal();
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                $scope.saveCampaign = function() {
                    if (!$scope.editMode) {
                        sendRequestAddNewCampaign(true);
                    } else if ($scope.forOneInfluencer) {
                        sendRequestEditCampaignForInfluencer(false);
                    } else {
                        sendRequestEditCampaign(false);
                    }
                }

                /**
                 * Send button
                 */
                $scope.onReviewCampaignSend = function () {
                    // needSendEmail = true
                    if ($scope.editMode && $scope.forOneInfluencer) {
                        sendRequestEditCampaignForInfluencer(true);
                    }
                }

                /**
                 * Review button
                 */
                $scope.parseTermParamValue = function(term) {
                    var paramsIsObject = term.params !== null && typeof term.params === 'object'
                    if (!term.hasParams || !paramsIsObject) {
                        return term.summary;
                    } else {
                        var display = term.summary;

                        Object.keys(term.params).forEach(function(paramName) {
                            display = display.replace('{{' + paramName + '}}', term.params[paramName].value);
                        });

                        return display;
                    }
                }

                $scope.reviewCampaign = function() {
                    $scope.showReviewCampaign = true;

                    $scope.selectedTermList = $scope.termList.filter(function(term) {
                        return term.ticked;
                    }).sort(function(termA, termB) {
                        return termA.contractSeq < termB.contractSeq ? -1 : (termA.contractSeq > termB.contractSeq ? 1 : 0);
                    });

                    angular.forEach($scope.mentionList, function(mention) {
                        switch (mention.type) {
                            case $scope.keywordTypeConsts.KEYWORD:
                                $scope.keywordList.push(mention);
                                break;
                            case $scope.keywordTypeConsts.URL:
                                $scope.urlList.push(mention);
                                break;
                            case $scope.keywordTypeConsts.HASH_TAG:
                                $scope.hashtagList.push(mention);
                                break;
                            default:
                                break;
                        }
                    });
                }

                /**
                 * Edit button
                 */
                $scope.onReviewCampaignEdit = function() {
                    $scope.showReviewCampaign = false;
                }

                /**
                 * Cancel and Close buttons
                 */
            	$scope.closeCampaignModal = function() {
            		$modalInstance.close();
                }

            	$scope.onReviewCampaignCancel = function() {
            		$scope.closeCampaignModal();
                }

                function loadCampaign(campaignId) {
                    CampaignFormService.getCampaign(campaignId, false) // loader = false
                        .then(function(res){
                            var campaign = res.data;

                            $scope.campaignName = campaign.name;
                            $scope.campaignBrief = campaign.brief;
                            $scope.additionalInfo.value = campaign.additionalInfo;

                            $scope.campaignTypes.forEach(function(type) {
                                if (type.value === campaign.projectType) {
                                    type.ticked = true;
                                    $scope.selectCampaignType(type);
                                }
                            });

                            campaign.projectKeywords.forEach(function(campaignKeyword) {
                                $scope.mentionList.push({
                                    id: campaignKeyword.keyword.id,
                                    name: campaignKeyword.keyword.keyword,
                                    type: campaignKeyword.keyword.keywordType.id,
                                    status: campaignKeyword.keyword.status,
                                });
                            });
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                function loadCampaignTerms(campaignId, campaignInfluencerId) {
                    var loadTermsPromise;

                    if ($scope.forOneInfluencer) {
                        loadTermsPromise = CampaignFormService.getCampaignTermsForInfluencer(campaignId, campaignInfluencerId, false);
                    } else {
                        loadTermsPromise = CampaignFormService.getCampaignTerms(campaignId, false) // loader = false
                    }

                    loadTermsPromise.then(function(res){
                        var campaignTerms = angular.copy(res.data);

                        $scope.termList.forEach(function(term) {
                            campaignTerms.forEach(function(campaignTerm, index) {
                                if (term.id === campaignTerm.termId) {
                                    term.ticked = true;
                                    term.action = "edit";
                                    term.campaignTermId = campaignTerm.id;
                                    term.params = JSON.parse(campaignTerm.params);

                                    campaignTerms.splice(index, 1);
                                }
                            });
                        });

                        // Leftover is deleted terms for company but still be used by campaign or for an influencer
                        campaignTerms.forEach(function(campaignTerm, index) {
                            if (campaignTerm.isUsing) {
                                var deletedButUsingTerm = campaignTerm.term;
                                deletedButUsingTerm.ticked = true;
                                deletedButUsingTerm.action = "edit";
                                deletedButUsingTerm.campaignTermId = campaignTerm.id;
                                deletedButUsingTerm.params = JSON.parse(campaignTerm.params);

                                deletedButUsingTerm.customed = deletedButUsingTerm.companyId !== null;

                                replaceParamMarkupByInputTag(deletedButUsingTerm, deletedButUsingTerm.summary, 'term');

                                $scope.termList.push(deletedButUsingTerm);
                            }
                        });

                        $scope.termList = $scope.termList.sort(function(termA, termB) {
                            return termA.contractSeq < termB.contractSeq ? -1 : (termA.contractSeq > termB.contractSeq ? 1 : 0);
                        });

                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function loadCampaignInfluencers(campaignId) {
                    CampaignFormService.getCampaignInfluencers(campaignId, false) // loader = false
                        .then(function(res){
                            var campaignInfluencers = res.data;

                            campaignInfluencers.forEach(function(campaignInfluencer) {
                                $scope.influencerList.push({
                                    id: campaignInfluencer.influencerId,
                                    domain: campaignInfluencer.influencer.domain,
                                    profile_image: campaignInfluencer.influencer.profile_image,
                                });
                            });
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                function loadCampaignFiles(campaignId) {
                    CampaignFormService.getCampaignFiles(campaignId, false) // loader = false
                        .then(function(res){
                            var campaignFiles = res.data;

                            campaignFiles.forEach(function(campaignFile) {
                                var file = {
                                    id: campaignFile.id,
                                    fileId: campaignFile.fileId,
                                    contentType: campaignFile.contentType,
                                    name: campaignFile.fileName,
                                    action: 'none',
                                    downloadLink: CampaignFormService.getUploadedFileUrl(campaignFile.fileId)
                                };

                                file.thumbnail = getThumbnailSrc(file.contentType, file.fileId);

                                $scope.fileList.push(file);
                            });
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                /**
                 * Load initial data
                 */
                if (!$scope.editMode) {
                    $scope.campaignTypes[0].ticked = true;
                    $scope.selectCampaignType($scope.campaignTypes[0]);
                } else {
                    loadCampaign($scope.editingCampaignId);
                    loadCampaignInfluencers($scope.editingCampaignId);
                    loadCampaignFiles($scope.editingCampaignId);
                }
            }
        ])

})();